import { ReportsApi } from "../../api-machine-statistics";
import { APIOptionsWithoutAPIClass, useAPI } from "./useAPI";

export const useReportsAPI = <T>({
  initialValue,
  handleRequest,
}: APIOptionsWithoutAPIClass<T, ReportsApi>) => {
  return useAPI<T, ReportsApi>({
    initialValue,
    APIClass: ReportsApi,
    handleRequest,
  });
};
